import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { useIsMobile } from '../../hooks/useIsMobile';

const STATUS_STYLES = {
  Yes: 'bg-emerald-50 border-emerald-300 text-emerald-800 dark:bg-emerald-500/20 dark:border-emerald-500/40 dark:text-emerald-100',
  No: 'bg-rose-50 border-rose-300 text-rose-800 dark:bg-rose-500/20 dark:border-rose-500/40 dark:text-rose-100',
  'N/A': 'bg-slate-50 border-slate-300 text-slate-800 dark:bg-slate-500/20 dark:border-slate-500/40 dark:text-slate-200',
};

function getStatusClass(value) {
  if (!value) return 'bg-white border-slate-300 text-slate-700 dark:bg-slate-600/20 dark:border-slate-500/30 dark:text-slate-200';
  return STATUS_STYLES[value] || 'bg-white border-slate-300 text-slate-700 dark:bg-slate-600/20 dark:border-slate-500/30 dark:text-slate-200';
}

export default function QuickFieldChips({ fields, values, onUpdate, allowedFieldKeys }) {
  const isMobile = useIsMobile();
  const [activeField, setActiveField] = useState(null);
  const allowedSet = Array.isArray(allowedFieldKeys) && allowedFieldKeys.length
    ? new Set(allowedFieldKeys)
    : null;

  const quickFields = (fields || [])
    .filter((f) => f.group === 'quick' && f.isActive !== false)
    .filter((f) => (allowedSet ? allowedSet.has(f.fieldKey) : true));

  if (!quickFields.length) return null;

  return (
    <div className="mt-2 flex flex-col gap-2 sm:flex-row sm:flex-wrap">
      {quickFields.map((field) => {
        const value = values[field.fieldKey] || '';
        const label = `${field.label}: ${value || 'Select…'}`;
        if (isMobile) {
          return (
            <button
              key={field.fieldKey}
              type="button"
              className={`w-full px-3 py-2 rounded-xl text-xs border text-left ${getStatusClass(value)}`}
              onClick={() => setActiveField(field)}
            >
              {label}
            </button>
          );
        }
        return (
          <label
            key={field.fieldKey}
            className={`px-3 py-1 rounded-full text-xs border cursor-pointer ${getStatusClass(value)}`}
          >
            <span className="mr-2">{field.label}:</span>
            <select
              value={value}
              onChange={(e) => onUpdate(field.fieldKey, e.target.value)}
              className="bg-transparent text-inherit focus:outline-none"
            >
              <option value="">Select…</option>
              {(field.options || []).map((opt) => (
                <option key={opt} value={opt} className="bg-slate-800 text-white">
                  {opt}
                </option>
              ))}
            </select>
          </label>
        );
      })}

      {activeField && isMobile &&
        createPortal(
          <div className="fixed inset-0 z-[9999]">
            <button
              type="button"
              className="absolute inset-0 bg-black/40"
              onClick={() => setActiveField(null)}
            />
            <div className="absolute bottom-0 left-0 right-0 bg-slate-900 p-4 rounded-t-2xl border-t border-slate-700">
              <div className="flex items-center justify-between mb-3">
                <div className="text-white font-semibold">{activeField.label}</div>
                <button
                  type="button"
                  className="text-slate-300 hover:text-white"
                  onClick={() => setActiveField(null)}
                >
                  ✕
                </button>
              </div>
              <select
                value={values[activeField.fieldKey] || ''}
                onChange={(e) => {
                  onUpdate(activeField.fieldKey, e.target.value);
                  setActiveField(null);
                }}
                className="w-full px-3 py-2 rounded-lg bg-slate-800 text-white border border-slate-700"
              >
                <option value="">Select…</option>
                {(activeField.options || []).map((opt) => (
                  <option key={opt} value={opt} className="bg-slate-800 text-white">
                    {opt}
                  </option>
                ))}
              </select>
            </div>
          </div>,
          document.body
        )}
    </div>
  );
}


